<template>
  <div class="report-firewall-summary-monitor">
    <div class="search-area">
      <el-select v-model="query.by" placeholder="Select" @change="clearData">
        <el-option
          v-for="item in [
            { label: 'Date', value: 'date' },
            { label: 'Year', value: 'year' },
          ]"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="query.year"
        placeholder="Year"
        style="width: 100px"
        v-if="query.by === byYear"
      >
        <el-option
          v-for="item in year_option"
          :key="item.value"
          :label="item.value"
          :value="item.value"
        ></el-option>
      </el-select>

      <el-date-picker
        v-model="dateSearch"
        type="daterange"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        v-else
      >
      </el-date-picker>
      <el-button
        slot="append"
        type="primary"
        icon="el-icon-search"
        @click="getMonitorSummaryFirewall()"
        :loading="loading"
        >Search</el-button
      >
      <el-button icon="el-icon-download" type="success" @click="Report()"
        >Export</el-button
      >
    </div>

    <data-tables
      v-loading="loading"
      :data="tableData"
      border
      :page-size="10"
      :pagination-props="{
        background: true,
        pageSizes: [10, 20, 50, 100, 200],
      }"
    >
      <el-table-column prop="name" label="Name" header-align="center"  min-width="150" fixed="left">
      </el-table-column>
      <el-table-column prop="scenario" label="Scenario" header-align="center"  min-width="200">
      </el-table-column>
      <el-table-column prop="comment" label="Comment" header-align="center"  min-width="100">
      </el-table-column>
      <el-table-column prop="code" label="Member code" header-align="center" align="center"  min-width="120">
      </el-table-column>
      <el-table-column prop="alert" label="Alert" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag
            size="mini"
            effect="dark"
            :type="scope.row.alert === 'Yes' ? 'success' : 'info'"
            >{{ scope.row.alert }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="count" label="Count" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="approved" label="Approved" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="declined" label="Declined" header-align="center" align="center">
      </el-table-column>
      <el-table-column
        prop="tx_date_time"
        label="TX Date Time"
        header-align="center"
         min-width="120"
      >
      </el-table-column>
      <el-table-column prop="tx_type" label="TX Type" header-align="center" width="120">
      </el-table-column>
      <el-table-column
        prop="tx_direction"
        label="TX Direction"
        header-align="center"
         min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="max_valume_of_fund"
        label="Max valume fund"
        header-align="center"
        align="center"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="refertypecode"
        label="Detail"
        header-align="center"
        align="center"
        fixed="right"
        width="140"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="showDetail(scope.row.refertypecode)"
          >
            View transaction
          </el-button>
        </template>
      </el-table-column>
    </data-tables>

    <el-dialog title="Detail firewall monitor summary" :visible.sync="dialogTableVisible" width="98%">

      <data-tables :data="tableDetail" size="mini" border :page-size="50"
      :pagination-props="{
        background: true,
        pageSizes: [10, 20, 50, 100, 200],
      }">
        <el-table-column property="createdDate" label="Created" min-width="150"></el-table-column>
        <el-table-column property="code" label="code" min-width="120"></el-table-column>
        <el-table-column property="refertypecode" label="Refertypecode" min-width="300"></el-table-column>
        <el-table-column property="paymentuid" label="Payment uid"  min-width="200"></el-table-column>
        <el-table-column property="amount" label="amount"></el-table-column>
        <el-table-column property="currency" label="currency"></el-table-column>
        <el-table-column property="bankholderId" label="BankholderId" min-width="120"></el-table-column>
        <el-table-column property="tx_type" label="tx_type" min-width="100"></el-table-column>
        <el-table-column property="tx_direction" label="TX Direction" min-width="100"></el-table-column>
        <el-table-column property="payeeName" label="payeeName" min-width="200"></el-table-column>
        <el-table-column property="payeeAccountnumberIban" label="Acc/Iban"  min-width="100"></el-table-column>
        <el-table-column property="payeeSortcodeBic" label="Sortcode/Bic" min-width="100"></el-table-column>
        <el-table-column property="senderName" label="senderName" min-width="200"></el-table-column>
        <el-table-column property="senderAccountnumberIban" label="Acc/Iban" min-width="100"></el-table-column>
        <el-table-column property="senderSortcodeBic" label="Sortcode/Bic" min-width="100"></el-table-column>
        <el-table-column property="status" label="Status"></el-table-column>
        <el-table-column property="hitReason" label="Hit Reason" min-width="300"></el-table-column>
        <el-table-column property="singleVolumeCriteria" label="Amount Criteria" min-width="120"></el-table-column>
        <el-table-column property="totalVolumesCriteria" label="Total Criteria" min-width="100"></el-table-column>
        <el-table-column property="totalTransactionsCriteria" label="Total Transac" min-width="100"></el-table-column>
        <el-table-column property="blacklistMatch" label="Blacklist" min-width="100"></el-table-column>
        <el-table-column property="scopedateCriteria" label="Scopedate" min-width="100"></el-table-column>
        <el-table-column property="riskCountry" label="Risk Country" min-width="100"></el-table-column>
      </data-tables>
    </el-dialog>
  </div>
</template>

<script>
import {
  getFirewallMonitorSummary,
  reportFirewallMonitorSummaryExcel,
} from "@/api/firewall-report";
import { currentDateTime, dateFormat, currentYear, findObjectArray } from "@/utils";
export default {
  props: {
    project: String,
  },
  watch: {
    project(val, old) {
      this.project = val;
      this.getMonitorSummaryFirewall();
    },
  },
  data() {
    return {
      loading: false,
      dialogTableVisible: false,
      dateSearch: "",
      byDate: "date",
      byYear: "year",
      tableData: [],
      tableDetail: [],
      detailData: [],
      year_option: [],
      query: {
        by: "date",
        year: currentYear(),
        startDate: "",
        endDate: "",
      },

    };
  },
  methods: {
    SelectDate() {
      if (!this.project) {
        this.$confirm("Please select project", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        })
          .then(() => {})
          .catch(() => {});
        return false;
      }

      let formData = { ...this.query };
      if (formData.by === this.byDate) {
        delete formData.year;
        formData.startDate =
          this.dateSearch[0] ||
          currentDateTime("YYYY-MM-DD");
        formData.endDate =
          this.dateSearch[1] ||
          currentDateTime("YYYY-MM-DD");
      } else {
        delete formData.startDate;
        delete formData.endDate;
      }

      return formData;
    },
    clearData() {
      this.tableData = [];
    },
    getMonitorSummaryFirewall() {
      const formData = this.SelectDate();
      if (!formData) return false;
      this.loading = true;
      getFirewallMonitorSummary(this.project, formData).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            this.tableData = data.firstRowData;
            this.detailData = data.secondRowData;
          }
        }
      );
    },
    Report() {
      const formData = this.SelectDate();
      if (!formData) return false;
      reportFirewallMonitorSummaryExcel(this.project, formData);
    },
    dropdownMonthYear() {
      for (let y = currentYear() - 5; y <= currentYear(); y++) {
        this.year_option.push({ value: y.toString() });
      }
    },
    showDetail(refertypecode){
      this.tableDetail = findObjectArray(this.detailData, refertypecode, 'refertypecode');
      this.dialogTableVisible = true;

    },
  },

  created() {
    this.dropdownMonthYear();
  },
};
</script>

<style lang="scss">
.report-firewall-summary-monitor {
  .search-area {
    margin-bottom: 16px;
    button {
      margin-left: 10px;
      margin-bottom: 16px;
    }
    .el-date-editor,
    .el-select {
      margin-left: 10px;
      margin-bottom: 16px;
    }
  }

  .el-tag {
    text-transform: capitalize;
  }
}
</style>